var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithubLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.999,
    height: 60,
    viewBox: "0 0 59.999 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "github_1_",
    "data-name": "github (1)",
    d: "M30,0A30.117,30.117,0,0,0,0,30C0,44.061,9.867,56.834,22.969,60V50.075a7.223,7.223,0,0,1-8.1-3.6c-.682-1.15-1.89-2.4-3.15-2.305l-.309-3.5c2.725-.233,5.083,1.66,6.482,4.011a3.888,3.888,0,0,0,2.255,1.929A4.725,4.725,0,0,0,23.1,46.35c.279-2.223,1.3-3.056,2.067-4.227v0C17.354,40.955,14.24,36.81,13,33.538a13.765,13.765,0,0,1,2.137-13.2.471.471,0,0,0,.119-.364,11.508,11.508,0,0,1,.35-7.682c1.533.453,1.782-.456,6.657,2.506l.843.506c.352.21.242.09.594.064A25.459,25.459,0,0,1,30,14.48a25.569,25.569,0,0,1,6.383.908l.273.027c-.024,0,.074-.017.238-.115,6.091-3.689,5.872-2.483,7.505-3.014a11.7,11.7,0,0,1,.342,7.685c-.177.546,5.28,5.543,2.255,13.565-1.236,3.273-4.35,7.419-12.164,8.584v0c1,1.527,2.205,2.339,2.2,5.488V60C50.133,56.834,60,44.061,60,30A30.116,30.116,0,0,0,30,0Zm0,0",
    fill: "#90c900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubLight);
export default __webpack_public_path__ + "static/media/githubLight.0979a6f13a7ca65f17e5d6585c89834c.svg";
export { ForwardRef as ReactComponent };